export enum ProfileSurveyExitModalType {
  Dashboard = 'Dashboard',
  OverQuota = 'OverQuota',
  ProjectCompleted = 'ProjectCompleted',
}
